import { render } from "./EllipsisDropdown.vue?vue&type=template&id=10a06d06"
import script from "./EllipsisDropdown.vue?vue&type=script&lang=js"
export * from "./EllipsisDropdown.vue?vue&type=script&lang=js"

import "./EllipsisDropdown.vue?vue&type=style&index=0&id=10a06d06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__